//const API_BASE_URL = 'https://psf-backend.onrender.com'; // Replace with your IP
const API_BASE_URL = 'http://192.168.1.5:5000'; // Replace with your IP
//const API_BASE_URL = 'http://10.148.26.249:5000';
export default API_BASE_URL;
